import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import {
    themeReducer,
    rtlReducer,
    customizerReducer,
    newOrderTableReducer,
    sidebarReducer,
    roundBordersReducer,
    blocksShadowsReducer,
    pokemonReducer,
    cryptoTrendsReducer,
    globalQuotesReducer,
    quotesBySymbolReducer,
    topTenReducer,
    cryptoHistoryReducer,
    walletReducer,
    userReducer,
    appConfigReducer,
} from '@/stores/reducers';
import covidReducer from '@/containers/Maps/VectorMapWithRequestData/redux/covidReducer';
import todoReducer from '@/containers/Todo/redux/reducer';

const rootReducer = combineReducers({
    theme: themeReducer,
    rtl: rtlReducer,
    border: roundBordersReducer,
    shadow: blocksShadowsReducer,
    appConfig: appConfigReducer,
    customizer: customizerReducer,
    newOrder: newOrderTableReducer,
    sidebar: sidebarReducer,
    covid: covidReducer,
    todo: todoReducer,
    pokemon: pokemonReducer,
    cryptoTrends: cryptoTrendsReducer,
    globalQuotes: globalQuotesReducer,
    quotesBySymbol: quotesBySymbolReducer,
    topTen: topTenReducer,
    cryptoHistory: cryptoHistoryReducer,
    wallet: walletReducer,
    user: userReducer,
});

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
